
import React from 'react';
import ReactSelectCreatable from 'react-select/creatable';
import {css} from 'emotion';

export const FormEditBlockFieldChoices = function (props) {

  if (!props.block()?.component || props.block()?.component != 'DropdownInput')
    return (<></>);

  return (<>
    <label
      className={css`
        display: flex;
        gap: 8px;
        padding: 8px;
        border-style: solid;
        border-width: 1px;
        border-color: #d1d5db;
      `}
    >
      <div
        className={css`
          display: grid;
          place-content: start center;
          place-items: start center;
        `}
      >
        Choices
      </div>
      <div
        className={css`
          display: grid;
          place-content: stretch;
          place-items: center;
          width: 100%;
        `}
      >
        <ReactSelectCreatable
          styles={{
            container: (baseStyles, state) => ({
              ...baseStyles,
              width: '100%',
            }),
          }}
          isMulti
          value={props.block()?.props?.choices?.map?.(c => ({label: c, value: c})) ?? []}
          onChange={(val) => {
            props.block({
              ...props.block(),
              props: {
                ...props.block()?.props,
                choices: val.map(v => v.value),
              },
            });
          }}
        />
      </div>
    </label>
  </>);

};
